import { useState, useEffect } from 'react'
import { formattedFromNow } from 'utils/format_date'
import { useDispatch } from 'react-redux'
import { addMyResourcesInternalTimer } from 'action_creators/serverAccess/myResources'

const useProfileValidity = (approvalValidityTime, resourceId, profileId) => {
  const dispatch = useDispatch()
  const [profileValidityRemaining, setProfileValidityRemaining] = useState(null)

  useEffect(() => {
    let timeRemainingLoopId

    if (approvalValidityTime) {
      // eslint-disable-next-line no-extra-semi
      ;(function calculateTimeRemaining() {
        const timeDifference = Date.parse(approvalValidityTime) - Date.now()
        if (timeDifference < 0) {
          dispatch(
            addMyResourcesInternalTimer({
              resourceId,
              profileId,
            })
          )
          setProfileValidityRemaining(null)
          clearTimeout(timeRemainingLoopId)
        } else {
          setProfileValidityRemaining(formattedFromNow(approvalValidityTime))
          timeRemainingLoopId = setTimeout(calculateTimeRemaining, 1000)
        }
      })()
    } else {
      setProfileValidityRemaining(null)
      clearTimeout(timeRemainingLoopId)
    }

    return () => clearTimeout(timeRemainingLoopId)
  }, [approvalValidityTime])

  return profileValidityRemaining
}

export default useProfileValidity
